export default {"src":"/_next/static/media/ADD_USER_ICON.871d3b16.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};